/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconRadiusBottomLeft = createReactComponent(
  "radius-bottom-left",
  "IconRadiusBottomLeft",
  [["path", { d: "M19 19h-6a8 8 0 0 1 -8 -8v-6", key: "svg-0" }]]
);

export { IconRadiusBottomLeft as default };
//# sourceMappingURL=IconRadiusBottomLeft.js.map
